(() => {
  const BOTTOM_DEFAULT = '20px';
  const BOTTOM_STUCK = '80px';

  const applyPosition = (chatContainer, stuck) => {
    chatContainer.style.bottom = stuck ? BOTTOM_STUCK : BOTTOM_DEFAULT;
  };

  const init = () => {
    const stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    const shadowHost = document.querySelector('#zipchat-shadow-host');
    if (!stickyBar || !shadowHost?.shadowRoot) return false;

    const chatContainer = shadowHost.shadowRoot.querySelector('#widget-chat-container');
    if (!chatContainer) return false;

    applyPosition(chatContainer, stickyBar.dataset.stuck === 'true');

    new MutationObserver(() => {
      applyPosition(chatContainer, stickyBar.dataset.stuck === 'true');
    }).observe(stickyBar, { attributes: true, attributeFilter: ['data-stuck'] });

    return true;
  };

  const domObserver = new MutationObserver(() => {
    if (init()) domObserver.disconnect();
  });

  domObserver.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => domObserver.disconnect(), 15000);
})();
